import React from 'react'
import Typography from 'components/atoms/Typography'

export const faq = [
  {
    id: 1,
    question: 'Mengapa saya harus melanjutkan kuliah di KIT Cambodia?',
    answer: (
      <Typography component="p" variant="body">
        Ada banyak alasan untukmu kenapa harus melanjutkan studi di kampus ini. Berikut beberapa di antaranya: silabus dan kurikulum ter-update yang menyesuaikan kebutuhan industri, didukung fasilitas berkualitas, mendapatkan pengalaman belajar di luar negeri, lingkungan belajar yang nyaman, harga terjangkau, dan berpeluang mendapatkan beasiswa!
      </Typography>
    ),
  },
  {
    id: 2,
    question: 'Bagaimana cara mendaftar di KIT Cambodia?',
    answer: (
      <Typography component="p" variant="body">
        Untuk pendaftaran, kamu hanya perlu mengikuti langkah sederhana. Cukup klik <a href="https://goo.gl/4uGSY2" target="_blank" rel="noopener norefferer">"Daftar Sekarang"</a> dan isi semua informasi yang diperlukan. Jangan lupa klik "Kirim" saat selesai. Kamu akan mendapatkan email konfirmasi dengan informasi tentang proses pendaftaran yang lebih detail. Yang perlu kamu lakukan sekarang adalah mempersiapkan diri untuk mengikuti tes ujian masuk!
      </Typography>
    ),
  },
  {
    id: 3,
    question: 'Apakah ada tahapan dan kondisi tertentu yang perlu diikuti?',
    answer: (
      <Typography component="p" variant="body">
        Kamu akan mengikuti ujian secara online 1-2 minggu setelah pendaftaran. Tes yang diikuti tergantung pada jurusan yang kamu pilih.
        <br/>
        <br/>
        - Software engineering -> Tes Matematika, Tes IQ, English Proficiency Test (EPT) <br/>
        - International Leaders Hospitality Management -> Tes IQ, Tes EQ
      </Typography>
    ),
  },
  {
    id: 4,
    question: 'Dapatkah saya mendaftar secara online?',
    answer: (
      <Typography component="p" variant="body">
        Tentu saja. Jangan lupa klik "Daftar Sekarang"!
      </Typography>
    ),
  },
  {
    id: 5,
    question: 'Kapan hasil tes diumumkan?',
    answer: (
      <Typography component="p" variant="body">
        Sekitar 1-2 minggu setelah tes dilakukan. Jangan lupa cek email kamu secara teratur.
      </Typography>
    ),
  },
  {
    id: 6,
    question: 'Bagaimana peluang karier saya setelah lulus?',
    answer: (
      <Typography component="p" variant="body">
        Tak perlu khawatir dengan hal ini. KIT Cambodia memiliki jaringan kerja sama dengan banyak perusahaan sponsor di berbagai negara, yang siap merekrutmu.
        <br/><br/>
        Pilihan profesi yang beragam juga akan membuka jalan pada peluang kerja yang lebih luas lagi. Untuk lulusan teknik, bisa menjadi programmer, pengembang web, insinyur sistem, konsultan sistem TI, data scientist, technopreneur, dll.
        <br/><br/>
        Untuk lulusan manajemen perhotelan, dapat menjadi wirausahawan, pemasar, pemandu wisata, manajer hotel, dll.
      </Typography>
    ),
  },
  {
    id: 7,
    question: 'Beasiswa apa yang tersedia di KIT Cambodia?',
    answer: (
      <Typography component="p" variant="body">
        - Performance-based scholarship <br/>
        Diberikan kepada mahasiswa Jurusan Software Engineering yang berhasil memperoleh hasil yang baik selama perkuliahan. Jumlah bervariasi, tergantung prestasi yang diraih. Jumlah yang bisa didapatkan mencapai 15.100 USD.
        <br/><br/>
        - Sponsorship-based scholarship <br/>
        Diberikan kepada mahasiswa Jurusan Software Engineering yang berhasil mendapatkan pekerjaan di perusahaan sponsor. Besaran beasiswa mencapai 16.000 USD.
      </Typography>
    ),
  },
  {
    id: 8,
    question: 'Berapa total biaya kuliah yang dibutuhkan untuk keseluruhan studi?',
    answer: (
      <Typography component="p" variant="body">
        Biaya kuliah dibagi menjadi beberapa klasifikasi, seperti biaya semester, biaya peralatan sekolah, dan biaya akomodasi & makanan. Silahkan lihat detailnya di sini <a href="https://campus.quipper.com/directory/kirirom-institute-of-technology-kit-cambodia" target="_blank" rel="noopener norefferer">https://campus.quipper.com/directory/kirirom-institute-of-technology-kit-cambodia</a>
      </Typography>
    ),
  },
]

export const scholarships = [
  {
    id: 1,
    name: 'Performance-based scholarship',
    desc: 'Diberikan kepada mahasiswa yang berhasil memperoleh hasil yang baik selama perkuliahan. ',
    value: 'Jumlah bervariasi, tergantung prestasi yang diraih. Jumlah yang bisa didapatkan mencapai 15.100 USD',
  },
  {
    id: 2,
    name: 'Sponsorship-based scholarship',
    desc: 'Diberikan kepada mahasiswa yang berhasil mendapatkan pekerjaan di perusahaan sponsor.',
    value: '16.000 USD',
  },
]
